import { handleActions } from 'redux-actions';
import { NAMES as SERVER_PAYMENTS_DEAL_INFO_GET } from 'shared/redux/server/actions/payments/get-items-deal-info';


export default handleActions({
  [SERVER_PAYMENTS_DEAL_INFO_GET.SUCCESS]: (state, { payload }) => {
    const items = _.get(payload, 'response.data.items');

    return _(items)
      .filter({ item_type: 'item' })
      .reduce((prev, { item_id, deal_info }) => ({
        ...prev,
        [item_id]: deal_info,
      }), {});
  },
}, null);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/payments/videos-deal-info.js